import React from 'react';
import { InputLabel, MenuItem, Select, styled } from '@mui/material';

const SelectContainer = styled('div')(({ theme }) => ({
  'display': 'flex',
  'justifyContent': 'center',
  'width': '100%',
  '& .MuiInputBase-root': {
    'width': '100%',
    'borderRadius': 'calc(var(--sp-xxs)*2)'
  },
  '& .MuiSelect-select': {
    // 'padding': 'calc(var(--sp-xxs)*2) calc(var(--sp-md2)*1)',
    'backgroundColor': '#F8F8F8',
  },
}));

const Label = styled(InputLabel)(({ theme }) => ({
  'fontSize': 'var(--fs-md2)',
  'fontWeight': '600',
  'marginBottom': 'var(--sp-md)',
  'color': '#000',
  'lineHeight': 'normal'
}));

const SelectStyled = ({ label, options, className, errorText, id, labelColor, labelFontSize, labelFontWeight, style = {}, ...props }) => {
  const convertToPx = (v) => (typeof v === 'number' ? `${v}px` : v);
  const backgroundColor = style.backgroundColor ?? '#F8F8F8';
  const boxShadow = style.boxShadow;
  const borderRadius = style.borderRadius ?? 'calc(var(--sp-xxs)*2)';
  const inputFontSize = style.inputFontSize ? convertToPx(style.inputFontSize) : 'var(--fs-md2)';
  const inputFontWeight = style.inputFontWeight;
  const inputTextColor = style.color;
  const noBorder = Boolean(style.noBorder);
  return (
    <>
      {label && (
        <Label htmlFor={id} className='field-label' style={{ color: labelColor, fontSize: labelFontSize ? convertToPx(labelFontSize) : undefined, fontWeight: labelFontWeight }}>{label}</Label>
      )}
      <SelectContainer>
        <Select
          displayEmpty
          className={className}
          {...props}
          sx={{
              '&.MuiInputBase-root': {
                  borderRadius,
                  boxShadow,
                  minHeight:'calc(var(--fs-hero)*1.157894)',
                  '&.Mui-focused fieldset': {
                      borderColor: '#1976d2 !important'
                  }
              },
              '& .MuiSelect-icon': {
                  width: 'calc(var(--sp-lg)*1.13)',
                  height: 'calc(var(--sp-lg)*1.13)',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  right: 'calc(var(--sp-xxs)*2)'
              },
              '& .MuiInputBase-input': { 
                  paddingRight: 'calc(var(--sp-lg)*2)',
                  lineHeight: 'calc(var(--sp-lg)*1.5)'
              },
              '& .MuiSelect-select': {
                  fontSize: inputFontSize,
                  fontWeight: inputFontWeight,
                  color: inputTextColor,
                  backgroundColor,
                  lineHeight: 'calc(var(--sp-lg)*1.6)',
                  paddingTop: 'calc(var(--sp-xxs)*1.8) !important',
                  paddingBottom: 'calc(var(--sp-xxs)*1.8) !important'
              },
              '& .MuiOutlinedInput-notchedOutline': {
                  border: noBorder ? 'none' : undefined,
              }
          }}
        >
          {
            options.map(option => (
              <MenuItem value={option.value} sx={{ fontSize: inputFontSize, fontWeight: inputFontWeight }}>{option.label}</MenuItem>
            ))
          }
        </Select>
      </SelectContainer>
      {errorText}
    </>
  )
};

export default SelectStyled;
